import { render, staticRenderFns } from "./RecoveryCodeForm.vue?vue&type=template&id=2dcaca72&scoped=true"
import script from "./RecoveryCodeForm.vue?vue&type=script&lang=js"
export * from "./RecoveryCodeForm.vue?vue&type=script&lang=js"
import style0 from "./RecoveryCodeForm.vue?vue&type=style&index=0&id=2dcaca72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaca72",
  null
  
)

export default component.exports